export enum DISPERSION_METHOD_STATE_ENUMERATION {
  APPROVED = 'APPROVED',
  GRAY_ZONE = 'GRAY_ZONE',
  INVALID_CONFIRMATION = 'INVALID CONFIRMATION',
  DECLINED = 'DECLINED',
  CANCELED = 'CANCELED',
  ALTERNATIVE = 'ALTERNATIVE',
}
